<template>
    <div class="certificates-results">
        <div class="certificates-results__container">
            <z-card
                :key="index"
                target="_black"
                v-for="(item, index) in data"
            >
                <template
                    v-slot:title
                    v-if="item.title"
                >
                    {{ item.title.name }}
                </template>
                <template v-slot:content>
                    <div class="certificates-results__detail-item">
                        <span>{{ text.row1 }}</span>
                        <span class="evraz-red-text">№{{ item.number }}</span>
                    </div>
                    <div class="certificates-results__detail-item">
                        <span>{{ text.row2 }}</span>
                        <span class="evraz-red-text">{{ item.released }}</span>
                    </div>
                    <div class="certificates-results__detail-item">
                        <span>{{ text.row3 }}</span>
                        <ul class="u-bottom-margin--no">
                            <li
                                :key="index"
                                v-html="li"
                                v-for="(li, index) in item.material"
                            ></li>
                        </ul>
                    </div>
                    <div class="certificates-results__detail-item">
                        <span>{{ text.row4 }}</span>
                        <span class="evraz-red-text">{{ item.consignee }}</span>
                    </div>
                    <div class="certificates-results__detail-item">
                        <span>{{ text.row5 }}</span>
                        <span class="evraz-red-text">{{ item.date | momentFilter('DD/MM/YYYY') }}</span>
                    </div>
                </template>
            </z-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'results-check',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                row1: this.$root.lang === 'ru' ? 'Сертификат:' : 'Certificate:',
                row2: this.$root.lang === 'ru' ? 'Выпустил:' : 'Released:',
                row3: this.$root.lang === 'ru' ? 'Материал:' : 'Material:',
                row4: this.$root.lang === 'ru' ? 'Грузополучатель:' : 'Consignee',
                row5: this.$root.lang === 'ru' ? 'Дата Сертификата:' : 'Certificate Date'
            }
        }
    }
}
</script>
